export interface ImageData {
    url: string;
    file?: File;
}

export const urlToImageData = (url: string): ImageData => ({
    url,
    file: undefined,
});

export const fileToImageData = (file: File): ImageData => ({
    url: URL.createObjectURL(file),
    file,
});
